export default "__VITE_ASSET__xMJmmLGV__"